import { Stack, Typography } from '@mui/material'
import { FC } from 'react'
import type { FarmQuantificationUnit } from '@/types/apiModels'
import { derivePaddockCount } from '../helpers/deriveQUSummary'

type StratificationQUsAccordionSummaryProps = {
  qu: FarmQuantificationUnit
}

export const StratificationQUsAccordionSummary: FC<StratificationQUsAccordionSummaryProps> = ({
  qu,
}) => {
  const paddockCount = derivePaddockCount(qu)

  return (
    <Stack spacing={0.5}>
      <Typography variant="subtitle1">{`${qu.name ?? 'QU sin nombre'} (${qu.improvementYear})`}</Typography>
      <Typography color="text.secondary" variant="body2">
        {`Inicia ${qu.improvementYear} · ${paddockCount} lotes`}
      </Typography>
    </Stack>
  )
}
